type SwitchProps = {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Id of the text that names this switch (the row title). */
  labelledBy: string;
  describedBy?: string;
  disabled?: boolean;
};

/** An on/off control that reads as one to screen readers (role="switch"). */
export function Switch({ checked, onChange, labelledBy, describedBy, disabled = false }: SwitchProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      className="switch"
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span className="switch-knob" aria-hidden="true" />
    </button>
  );
}
